<template>
	<div class="admin-profile">
		<div class="vx-row">
			<div class="vx-col w-full xl:w-3/5 mb-5">
				<vx-card>
					<h1>{{ $t('profile') }}</h1>
					<div class="info mt-5 flex-col sm:flex-row">
						<div class="photo">
							<img :src="$store.state.auth.user.photo" alt="">
						</div>
						<div class="data mt-10 sm:mt-5">
							<div class="tables">
								<table>
									<tbody>
										<tr>
											<td>{{ $t('personName') }}</td>
											<td>{{$store.state.auth.user.first_name }} {{$store.state.auth.user.last_name }}</td>
										</tr>
										<tr>
											<td>E-Mail</td>
											<td>{{$store.state.auth.user.email }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<vs-button
						@click="$router.push('/profile/edit')"
						class="mt-10 edit-btn"
					>{{ $t('edit') }}</vs-button>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Accountant",
	data() {
		return {}
	},
	async mounted() {
		try {
			let res = await this.$http('/'+this.$store.state.auth.role+'/profile')
		} catch (e) {

		}
	},

}
</script>

<style>

</style>